$(function () {
  /* SlimMenu Prep */
  $('#navigation').slimmenu({
    resizeWidth: '1200',
    collapserTitle: '',
    animSpeed: 0,
    easingEffect: null,
    indentChildren: false,
    childrenIndenter: '&nbsp;',
    expandIcon: '',
    collapseIcon: ''
  });

  $('a:not([role=tab])').on('click', function(event) {
    // On-page links
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        var $target = $(target);
        //$target.focusWithoutScrolling();
        $('html, body').animate({
          scrollTop: target.offset().top - 150
        }, 700);
        $('.collapse-button').removeClass('expanded').children('i').removeClass('fa-times').addClass('fa-bars');
        $('.slimmenu.collapsed').hide();
      }
    }
  });

  $('.food-menu-nav .control-left').on('click', function(){
    var list = $(this).parent().find('.nav');
    list.animate({
      scrollLeft:"-=200px"
    }, "slow");
  });
  $('.food-menu-nav .control-right').on('click', function(){
    var list = $(this).parent().find('.nav');
    list.animate({
      scrollLeft:"+=200px"
    }, "slow");
  });
  $('.collapsed .menu-tab-item').on('click', function(){
    var list = $(this).parent();
    var listWidth = list.width();
    var itemLeft = $(this).position().left;
    var width = $(this).width();
    var a = (listWidth - width) / 2;
    var difference = a - itemLeft + 54;
    list.animate({
      scrollLeft:"-=" + difference
    }, "slow");
  });
  $(window).on('scroll', function(){
    if(window.pageYOffset == 0) {
      $('header.sticky-top').removeClass('scrolled');
    } else {
      $('header.sticky-top').addClass('scrolled');
    }
  });
});